module.exports = __webpack_public_path__ + "img/app.bc33bc1c.png";